import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`
export default {
    overview: {
        url: `${customerApi}/api/mass_sending/{id}/overview`,
        type: 'GET',
    },
    detail: {
        url: `${customerApi}/api/mass_sending/{id}/replicator`,
        type: 'GET',
    },
}
